import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/map'
import {Observable} from "rxjs/Observable";
import { HttpHeaders,HttpParams, HttpErrorResponse} from '@angular/common/http';
import { Headers } from '@angular/http';
import { environment } from '../environments/environment.prod';
import { Router, ActivatedRoute } from '@angular/router';
import { RequestOptions, RequestMethod } from '@angular/http';


@Injectable()
export class AuthServiceService implements OnInit{
    requestoptions;
    headers;
    currentUserData;
    year;
    domainUrl;
    
    constructor(private http: HttpClient,private router: Router) { 
      
    }
    ngOnInit(){

    }
  
  
  login(user) {
      this.domainUrl = localStorage.getItem('domainUrl'); 
      this.year = '2021-2022';
      var userobj = user ;      
      const headers = new HttpHeaders().set("Content-type", "application/json").set("Accept", "application/json").set('academic-year',this.year).set('instance',this.domainUrl);
      const params = new HttpParams()
       return this.http.put(environment.login, userobj, {headers,
         params}).map(response => {
         if(response){ 
           let data = JSON.stringify(response);         
           localStorage.setItem('currentUser',data);
           localStorage.setItem('authReq',user);
           return data;
         }

       }).catch(this.handleError);
     }   
  getLoginDomain(paramDomain){
       let paramval = paramDomain;
       const headers = new HttpHeaders().set("Content-type", "application/json").set("Accept", "application/json");
       const params = new HttpParams()
       .set('instance', paramval);
      // return this.http.get(domain?+"instance="+domainParam)
       return this.http.get(environment.login, {
         headers,
         params
       }).map(response => { 
         return response;
      });
     }
    
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        var domain = localStorage.getItem('domainUrl');
        if(domain){
          this.router.navigate(['/login', domain]);
        }
    }
    private handleError(error: HttpErrorResponse) {
      if (error.error instanceof ErrorEvent) {
        //this.logout();
        console.error('An error occurred:', error.error.message);
      } else { 
        console.error(
          `Backend returned code ${error.status}, ` +
          `body was: ${error.error}`);
      }
      // return an observable with a user-facing error message
      return 'Something bad happened; please try again later.';
    }
}


// WEBPACK FOOTER //
// D:/Laxmi/angular/forms/XpressForms/src/app/auth-service.service.ts